import GET_DIGITAL_SIGNATURE_PARAMS from './getDigitalSignatureParams.gql';
import ME from './me.gql';

export {
  GET_DIGITAL_SIGNATURE_PARAMS,
  ME,
};
